import { createTheme } from '@mui/material/styles';

export const robotaxmakerTheme = createTheme({
  palette: {
    primary: {
      light: '#42a5f5',
      main: '#0066cc',
      dark: '#0157bb',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ff80ab',
      main: '#E91E63',
      dark: '#d81b60',
      contrastText: '#fff',
    }
  }
});
